import { FeatureFlag } from '../FeatureFlag';

export const enableTtsAlerts = new FeatureFlag({
    key: 'enable-tts-alerts',
    defaultValue: false,
});
